export default __webpack_public_path__ + "static/media/blacktransparentlogo.f134170b.png";